<template>
    <b-card>
        <!-- filter section -->
        <b-card-header>
            <b-row>
                <b-col>
                    <b-form-input
                        placeholder="Filter..."
                        addon-right-icon="ni ni-zoom-split-in"
                        v-model="query"
                        @input="updateQuery"
                    ></b-form-input>
                </b-col>
            </b-row>
        </b-card-header>

        <!-- table to display the audit logs -->
        <div class="table-responsive">
            <b-table responsive :items="auditLogs" :fields="fields">
                <!-- field templates -->
                
                <!-- display the role as the first and last name of the user -->
                <template #cell(role)="{ item }">
                    <span>
                        {{ item.user.first_name + ' ' + item.user.last_name }}
                    </span>
                </template>

                <!-- display the message as html -->
                <template #cell(message)="{ item }">
                    <span v-html="item.message"></span>
                </template>
            </b-table>
        </div>

        <b-row>
            <b-col>
                <b-pagination
                    class="float-right"
                    v-model="pagination.page"
                    :total-rows="pagination.total"
                    :per-page="pagination.pageSize"
                    aria-controls="roleTable"
                    pills
                    align="right"
                ></b-pagination>
            </b-col>
        </b-row> 
    </b-card>
</template>
<script>
import _ from 'lodash'
import moment from 'moment'

export default {
    name: 'audit-log-table',
    props: {
        type: {
            type: String,
        },
        title: String,
    },
    data() {
        return {
            /** filter query */
            query: '',
            /** the current page being viewed */
            page: 1,
            /** the fields for the audit log table */
            fields: [
                {
                    key: 'created_at',
                    label: 'Date',
                    formatter: (value, key, item) =>
                        moment(new Date(item.created_at)).format('YYYY-MM-DD'),
                },
                'type',
                { key: 'order_id', label: 'Order' },
                'role',
                'message',
            ],
        }
    },

    /** Search by filter criteria on component mount */
    mounted() {
        if (this.$route.query.query) this.query = this.$route.query.query
        this.doSearch()
    },

    methods: {
        updateQuery: _.debounce(function(query) {
            this.query = query
            this.$router.push({ query: { query: this.query } })
            this.doSearch()
        }, 200),
        changePage: function(page) {
            this.page = page
            this.$router.push({ query: { page: page } })
            this.doSearch()
        },
        doSearch() {
            console.log('query:', this.query)
            console.log('page:', this.page)
            this.$store.dispatch('auditlogs/fetch', {
                query: this.query,
                page: this.page,
            })
        },
        truncate(text, length) {
            return _.truncate(text, { length: length })
        },
    },

    computed: {
        auditLogs() {
            return this.$store.state.auditlogs.items
        },
        pagination() {
            return this.$store.state.auditlogs.pagination || {}
        },
    },
}
</script>
<style></style>
